import { FC } from 'react';
import { Box, Button, Stack } from '@chakra-ui/react';
export interface CbSwitchButtonProps {
  valueToCheck: string;
  options: string[];
  setMetric: (value: string) => void;
  setFieldValue: any;
  value: string;
}
export const CbSwitchButton: FC<CbSwitchButtonProps> = ({
  valueToCheck,
  options,
  setMetric,
  setFieldValue,
  value
}) => {
  return <Box borderRadius={50} borderWidth={'1px'} borderColor="cloud.300" width="100px" data-sentry-element="Box" data-sentry-component="CbSwitchButton" data-sentry-source-file="CbSwitchButton.tsx">
      <Stack direction="row" spacing={0} align="center" data-sentry-element="Stack" data-sentry-source-file="CbSwitchButton.tsx">
        {options.map(option => <Button key={option} height={10} color={valueToCheck === option ? 'white' : 'text.primary'} backgroundColor={valueToCheck === option ? 'luigisPants.500' : 'transparent'} _hover={{
        bg: '',
        border: ''
      }} _active={{
        bg: '',
        border: ''
      }} _focus={{
        bg: '',
        border: ''
      }} borderRadius={50} onClick={() => {
        setMetric(option);
        setFieldValue(value, option === options[0] ? true : false);
      }}>
            {option}
          </Button>)}
      </Stack>
    </Box>;
};